import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatINR } from "@/lib/api";

const STATUS_COLOR = {
  confirmed: "text-blue-400",
  packed: "text-yellow-400",
  shipped: "text-purple-400",
  out_for_delivery: "text-orange-400",
  delivered: "text-green-400",
  cancelled: "text-red-400",
};

export default function Orders() {
  const [orders, setOrders] = useState(null);
  useEffect(() => { api.get("/orders").then((r) => setOrders(r.data.orders)); }, []);

  if (orders === null) return <div className="py-24 text-center font-display tracking-widest">LOADING…</div>;

  if (!orders.length) {
    return (
      <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="orders-empty">
        <h1 className="font-display text-5xl tracking-tighter mb-4">NO ORDERS YET</h1>
        <Link to="/shop/all" className="inline-block bg-black text-white px-8 py-4 font-display tracking-widest text-sm">START SHOPPING</Link>
      </div>
    );
  }

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12" data-testid="orders-page">
      <h1 className="font-display text-6xl tracking-tighter mb-10">MY ORDERS</h1>
      <div className="space-y-4">
        {orders.map((o) => (
          <Link key={o.id} to={`/order/${o.id}`} className="block border border-black/15 p-6 hover:border-black transition-colors" data-testid={`order-row-${o.id}`}>
            <div className="grid md:grid-cols-4 gap-4 items-center">
              <div>
                <div className="font-mono text-xs text-black/40">ORDER NO</div>
                <div className="font-display tracking-tight">{o.order_no}</div>
              </div>
              <div>
                <div className="font-mono text-xs text-black/40">DATE</div>
                <div>{new Date(o.created_at).toLocaleDateString()}</div>
              </div>
              <div>
                <div className="font-mono text-xs text-black/40">TOTAL</div>
                <div className="font-display">{formatINR(o.pricing.total)}</div>
              </div>
              <div>
                <div className="font-mono text-xs text-black/40">STATUS</div>
                <div className={`font-display tracking-widest text-sm ${STATUS_COLOR[o.status] || "text-black"}`}>{o.status.toUpperCase().replace(/_/g, " ")}</div>
              </div>
            </div>
            <div className="mt-4 flex gap-2 overflow-x-auto">
              {o.items.slice(0, 6).map((it, i) => (
                <img key={`${o.id}-${it.product_id}-${it.size}-${it.color}-${i}`} src={it.image} alt="" className="w-12 h-16 object-cover flex-shrink-0" />
              ))}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
